import { inject } from '@angular/core';
import { CanMatchFn } from '@angular/router';
import { AppReadyService } from '../services/app-ready/app-ready.service';

/**
 * Route-matching gate that blocks navigation until the app's boot sequence
 * has finished. Applied via `canMatch` on every route that depends on
 * resolved auth + initial state — i.e. anything beyond truly anonymous
 * pages.
 *
 * Because `canMatch` runs ahead of `canActivate` and resolvers, every guard
 * downstream can assume the readiness invariant and read state signals
 * synchronously. This is the *only* place in the app that waits for boot.
 */
export const appReadyMatch: CanMatchFn = () => {
  const ready = inject(AppReadyService);
  return ready.isReady() ? true : ready.ready$;
};
